import { Amount } from '@shared/models/common/amount.model';


export class DetailOrderEstimateSummary {
  voucherQuantity: number;
  voucherValue: Amount;
  pocketsChequeQuantity?: number;
}
